import React from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTabSwiper, { EcoTabSwiperItemProps } from 'eco-design/sections/eco-tab-swiper';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import { useProductStore } from '@elem/compPage/rapid-mag-power-bank/ProductProvider';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import { IPageStatus } from '@elem/compPage/rapid-mag-power-bank/config/IPageStatus';

const TabSwiper: React.FC = ({}) => {
    const { t } = useLang('theProductV2.TabSwiper');
    const { pageStatus } = useProductStore();

    const webpOrJpg = useWebpOrJpg('#rapid-mag-TabSwiper-V2');

    const items: EcoTabSwiperItemProps[] = [
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559223893/1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559287720/1.webp',
            ),
            pad: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559223893/1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559287720/1.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559223352/1-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559287377/1-m.webp',
            ),
            tabLabel: t('tab1'),
            bottomContent: t('content1'),
            tabValue: 'A1',
        },
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559225007/2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559289041/2.webp',
            ),
            pad: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559225007/2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559289041/2.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559223529/2-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559287579/2-m.webp',
            ),
            tabLabel: t('tab2'),
            bottomContent: t('content2'),
            tabValue: 'A2',
        },
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559224504/3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559288357/3.webp',
            ),
            pad: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559224504/3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559288357/3.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559224757/3-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559288742/3-m.webp',
            ),
            tabLabel: t('tab3'),
            bottomContent: t('content3'),
            tabValue: 'A3',
        },
        {
            pc: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1762482349534/4.png',
                'https://websiteoss.ecoflow.com/upload/image/1762482350193/4.webp',
            ),
            pad: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1762482349534/4.png',
                'https://websiteoss.ecoflow.com/upload/image/1762482350193/4.webp',
            ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1762482349236/4-h5.png',
                'https://websiteoss.ecoflow.com/upload/image/1762482349857/4-h5.webp',
            ),
            tabLabel: t('tab4'),
            bottomContent: t('content4'),
            tabValue: 'A4',
        },
        {
            pc:
                pageStatus === IPageStatus.statusC
                    ? webpOrJpg(
                          'https://websiteoss.ecoflow.com/upload/image/1761559225247/5.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1761559289401/5.webp',
                      )
                    : webpOrJpg('https://websiteoss.ecoflow.com/upload/image/1762138410078/5.png'),
            pad:
                pageStatus === IPageStatus.statusC
                    ? webpOrJpg(
                          'https://websiteoss.ecoflow.com/upload/image/1761559225247/5.jpg',
                          'https://websiteoss.ecoflow.com/upload/image/1761559289401/5.webp',
                      )
                    : webpOrJpg(
                          'https://websiteoss.ecoflow.com/upload/image/1762138410078/5.png',
                          'https://websiteoss.ecoflow.com/upload/image/1762138634735/5.webp',
                      ),
            h5: webpOrJpg(
                'https://websiteoss.ecoflow.com/upload/image/1761559225606/5-m.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1761559289740/5-m.webp',
            ),
            tabLabel: t('tab5'),
            bottomContent: t('content5'),
            tabValue: 'A5',
        },
    ].filter(Boolean) as EcoTabSwiperItemProps[];

    return (
        <section className="GtmModuleData-section" id="rapid-mag-TabSwiper-V2" data-section-id={'rapid-mag-TabSwiper-V2'} data-section-title={t('title')}>
            <EcoSpace />
            <EcoTitle className={style.title} title={t('title')} />
            <EcoSpaceSmall />
            <EcoTabSwiper className={style.comp} gtmTitle={t('title')} items={items} />
        </section>
    );
};
export default TabSwiper;
